<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="relative new-header">
    <div class="header-text"></div>
    <div class="vx-navbar-wrapper " :class="classObj">
      <vs-navbar
        class="vx-navbar navbar-custom navbar-skelton br-15r "
         :color="navbarColorLocal"
        :class="textColor"
        :style="headerText"
      >
        <router-link tag="div" to="/" class="vx-logo cursor-pointer mx-auto flex items-center logo-padding">
          <logo class="w-8 mr-6 fill-current text-primary" />
          <span class="ml-10">{{companyName}}</span>
        </router-link>

        <vs-spacer />

        <i18n />

        <profile-drop-down-home v-if="$store.getters.roles=='user'" />
        <profile-drop-down
          v-if="$store.getters.roles=='super_admin'||$store.getters.roles=='admin'||$store.getters.roles=='staff'"
        />
      </vs-navbar>
    </div>
  </div>
</template>

<style scoped>
.navbar-floating .vx-navbar {
   /* border-radius: .5rem; */
    /* padding: .2rem 1rem; */
}
.new-header {
  margin-bottom: 0%;
}
.br-15r {
  border-radius: 1.2rem;
  -moz-box-shadow: 0px 3px 8px rgb(100, 100, 100);
  -webkit-box-shadow: 0px 3px 8px rgb(100, 100, 100);
  box-shadow: 0px 3px 8px rgb(100, 100, 100);
}
.vx-navbar-wrapper {
  position: inherit;
  width: 100% !important;
  z-index: auto;
}
.vx-logo .vx-logo-text {
  font-size: 16px;
  font-weight: 600;
}
.logo-padding{
  padding:0.2rem;
}
.vx-navbar{
  z-index: -1 !important;
}
</style>
<script>
import Bookmarks from "./components/Bookmarks.vue";
import I18n from "./components/I18n.vue";
import SearchBar from "./components/SearchBar.vue";
import NotificationDropDown from "./components/NotificationDropDown.vue";
import ProfileDropDownHome from "./components/ProfileDropDownHome.vue";
import ProfileDropDown from "./components/ProfileDropDown.vue";
import Logo from "../Logo.vue";
import { getLocalData,clearLocalData } from "@/utils/auth";
export default {
  name: "the-navbar-vertical-home",
  props: {
    navbarColor: {
      type: String,
      default: "#fff"
    }
  },
  data() {
    return {
    loginUser: [],
      companyName: "",
      header: true,
      styleData: [],
      headerText: {}
    };
  },
  components: {
    Bookmarks,
    I18n,
    SearchBar,
    NotificationDropDown,
    ProfileDropDown,
    ProfileDropDownHome,
    Logo
  },
  computed: {
   navbarColorLocal() {
      if(this.styleData.length <= 0 )
       {

         return this.$store.state.app.theme === "dark" &&
          this.navbarColor === "#fff"
          ? "#10163a"
          : this.navbarColor;
       } else {
         return this.styleData.form_background_color;

       }
    },
    verticalNavMenuWidth() {
      return this.$store.state.app.verticalNavMenuWidth;
    },
    textColor() {
      return {
        "text-white":
          (this.navbarColor != "#10163a" &&
            this.$store.state.app.theme === "dark") ||
          (this.navbarColor != "#fff" && this.$store.state.app.theme !== "dark")
      };
    },
    windowWidth() {
      return this.$store.state.app.windowWidth;
    },
    // NAVBAR STYLE
    classObj() {
      if (this.verticalNavMenuWidth == "default") return "navbar-default";
      else if (this.verticalNavMenuWidth == "reduced") return "navbar-reduced";
      else if (this.verticalNavMenuWidth) return "navbar-full";
    },
    getCompanyName() {
      return this.$store.getters.companyName;
    },
    getHeader() {
      return this.$store.getters.header;
    }
  },
  watch: {
    getCompanyName: function(newValue) {
      this.companyName = newValue;
    },
    getHeader: function(newValue) {
      this.header = newValue;
    },
    $route (to, from){
        if(this.$route.params.slug){
          this.getCompanyLogoImage()
        }else this.getSettings();
    },
  },
   created() {
    this.loginUser = this.$store.getters.currentUser;
    if (this.$route.params.slug) {
      this.getCompanyLogoImage();
    } else this.getSettings();


  },

  methods: {
       getCustomStyle(id) {

      let data = {
          company_id: id,
        };
      this.$store
        .dispatch("GetCustomStyle", data)
        .then((res) => {
          this.styleData = res.data.data; //form_background_color
          this.headerText = {
            color: res.data.data.form_text_color + " !important",
          };
        })
        .catch((error) => {
          this.$log.error(
            "File : BookingForm.vue | Function : getCustomStyle() | Error :",
            error
          );
          return false;
        });
    },
  getCompanyLogoImage(){
    this.$store
        .dispatch("CompanyDetails", this.$route.params.slug)
        .then((res) => {
            this.companyName = res.data.data.company_name;
              this.getCustomStyle( res.data.data.id);
        })
    },
    getSettings() {
      this.$store
        .dispatch("GetSystemSettings")
        .then((res) => {
          this.$vs.loading.close();
            this.companyName = res.data.data.title;

        })
        .catch((error) => {
          this.$log.error(
            "File : getSetting.vue | Function : getSettings() | Error :",
            error
          );
          return false;
        });
    },
    showSidebar() {
      this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);
    }
  }
};
</script>

